import React from "react";
import { compose, withProps, lifecycle } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
  DirectionsRenderer,
} from "react-google-maps";
// import { PlusIcon } from "../../asset";
import PlusIcon from "../../asset/Mail-Icon.svg";
import Pin from "../../asset/PinMaps-Icon.svg"
import { Spin } from "antd";

const MAP_API = "https://maps.googleapis.com/maps/api/js?";
const API_KEY = "AIzaSyBoFXsJLCpUvgSmLqLEQSqaGphqKfxnlfk";

const MapsSmall = compose(
  withProps({
    googleMapURL: `${MAP_API}libraries=places&key=${API_KEY}`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `180px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)
((props) => {
  return (
    <>
      <GoogleMap
        defaultZoom={18}
        defaultCenter={{
          lat: props.lat ? Number(props.lat) : -6.294844,
            lng: props.long ? Number(props.long): 106.840837,
        }}
      >
        <Marker
        onClick={()=>props.onClicks()}
          position={{
            lat: props.lat ? Number(props.lat) : -6.294844,
            lng: props.long ? Number(props.long): 106.840837,
          }}
          name={"RSUD Pasar Minggu"}
          icon={{
            url: Pin,
            // anchor: new window.google.maps.Point(5, 58),
          }}
        >

        </Marker>
      </GoogleMap>
    </>
  );
});

export default MapsSmall;
